<div
  id="kt_app_sidebar"
  class="app-sidebar flex-column"
  data-kt-drawer="true"
  data-kt-drawer-name="app-sidebar"
  data-kt-drawer-activate="{default: true, lg: false}"
  data-kt-drawer-overlay="true"
  data-kt-drawer-width="225px"
  data-kt-drawer-direction="start"
  data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
>
  <!-- Logo section -->
  <div class="app-sidebar-logo px-9" id="kt_app_sidebar_logo">
    <div>
      <img
        alt="Logo"
        src="assets/media/back-office-logo.png"
        class="app-sidebar-logo-default"
      />
      <img
        alt="Logo"
        src="assets/media/back-office-logo-min.png"
        class="h-20px app-sidebar-logo-minimize"
      />
    </div>
    <!-- Toggle Sidebar Button -->
    <div
      id="kt_app_sidebar_toggle"
      class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
      data-kt-toggle="true"
      data-kt-toggle-state="active"
      data-kt-toggle-target="body"
      data-kt-toggle-name="app-sidebar-minimize"
    >
      <i class="fa-solid fa-arrow-left rotate-180"></i>
    </div>
  </div>
  <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
    <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
      <div
        id="kt_app_sidebar_menu_scroll"
        class="scroll-y my-5 mx-3"
        data-kt-scroll="true"
        data-kt-scroll-activate="true"
        data-kt-scroll-height="auto"
        data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
        data-kt-scroll-wrappers="#kt_app_sidebar_menu"
        data-kt-scroll-offset="5px"
        data-kt-scroll-save-state="true"
        style="height: 45rem"
      >
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 mb-20"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <!-- Dashboard -->
          <div class="menu-item">
            <a class="menu-link" [routerLink]="['/dashboard/main']">
              <span class="menu-icon">
                <i class="fa-solid fa-clipboard-list"></i>
              </span>
              <span class="menu-title">{{
                "dashboard.dashboardMenuTitle" | translate
              }}</span>
            </a>
          </div>
          <!-- Users -->
          <div data-kt-menu-trigger="click" class="menu-item menu-accordion">
            <span class="menu-link cursor-pointer">
              <span class="menu-icon">
                <i class="fa-solid fa-user"></i>
              </span>
              <span class="menu-title">{{ "users" | translate }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              class="menu-sub menu-sub-accordion"
              style="display: none; overflow: hidden"
              kt-hidden-height="125"
            >
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/user/list']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{ "userList" | translate }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/user/create']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{ "createUser" | translate }}</span>
                </a>
              </div>
            </div>
          </div>
          <!-- Organizations -->
          <div data-kt-menu-trigger="click" class="menu-item menu-accordion">
            <span class="menu-link cursor-pointer">
              <span class="menu-icon">
                <i class="fa-solid fa-building"></i>
              </span>
              <span class="menu-title">{{ "organizations" | translate }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              class="menu-sub menu-sub-accordion"
              style="display: none; overflow: hidden"
              kt-hidden-height="125"
            >
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/organization/list']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "organizationList" | translate
                  }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/organization/create']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "createOrganization" | translate
                  }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/branch/list']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{ "branchList" | translate }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a [routerLink]="['/branch/create']" class="menu-link">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "createBranch" | translate
                  }}</span>
                </a>
              </div>
            </div>
          </div>
          <!-- Notification Contents -->
          <div data-kt-menu-trigger="click" class="menu-item menu-accordion">
            <span class="menu-link cursor-pointer">
              <span class="menu-icon">
                <i class="fa-solid fa-bell"></i>
              </span>
              <span class="menu-title">{{
                "notificationContents" | translate
              }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              class="menu-sub menu-sub-accordion"
              style="display: none; overflow: hidden"
              kt-hidden-height="125"
            >
              <div class="menu-item cursor-pointer">
                <a
                  [routerLink]="['/notification-contents/push']"
                  class="menu-link"
                >
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "pushNotifications" | translate
                  }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a
                  [routerLink]="['/notification-contents/email']"
                  class="menu-link"
                >
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "emailNotifications" | translate
                  }}</span>
                </a>
              </div>
              <div class="menu-item cursor-pointer">
                <a
                  [routerLink]="['/notification-contents/system']"
                  class="menu-link"
                >
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">{{
                    "systemNotifications" | translate
                  }}</span>
                </a>
              </div>
            </div>
          </div>
          <!-- Conclusion Options -->
          <div class="menu-item">
            <a class="menu-link" [routerLink]="['/conclusion-options/list']">
              <span class="menu-icon">
                <i class="fa-solid fa-file-invoice"></i>
              </span>
              <span class="menu-title">{{
                "conclusionOptions" | translate
              }}</span>
            </a>
          </div>
          <!-- Surveys -->
          <div class="menu-item">
            <a class="menu-link" [routerLink]="['/survey/list']">
              <span class="menu-icon">
                <i class="fa-solid fa-list-ul"></i>
              </span>
              <span class="menu-title">{{
                "surveyManagements" | translate
              }}</span>
            </a>
          </div>
          <!-- Surveys -->
          <div class="menu-item">
            <a class="menu-link" [routerLink]="['/information-setup']">
              <span class="menu-icon">
                <i class="fa-solid fa-gear"></i>
              </span>
              <span class="menu-title">{{
                "informationSetup" | translate
              }}</span>
            </a>
          </div>
        </div>
        <div
          class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 mt-15 px-2 pb-8"
          id="#kt_app_sidebar_menu"
          data-kt-menu="true"
          data-kt-menu-expand="false"
        >
          <div class="menu-item cursor-pointer">
            <a (click)="backToDerm()" class="menu-link">
              <span class="menu-icon">
                <i class="fa-solid fa-arrow-left-long"></i>
              </span>
              <span class="menu-title">{{
                "backToDermalogic" | translate
              }}</span>
            </a>
          </div>
          <div class="menu-item">
            <a class="menu-link" target="_blank">
              <span class="menu-title"
                >{{ "madeWith" | translate }}
                <i class="fa-solid fa-heart mx-2"></i>
                {{ "by" | translate }} Amatis</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
